export default __webpack_public_path__ + "img/DATABASE.355991a8.png";